import {FC } from "react";


interface IconChevronUpSVGProps {
    initialOpen?: boolean;
    spinning?: boolean;
}

const IconChevronUpSVG: FC<IconChevronUpSVGProps> = (props) => {
    return (
        <svg
            viewBox="0 0 20 20"
            fill="none"
            className={`w-9 h-9 text-primary-400 transform transition-transform duration-400 ${props.initialOpen ? "rotate-180" : ""} ${props.spinning ? "animate-spin" : ""}`}
        >
            <path d="M5 8l5 5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default IconChevronUpSVG;